var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMealsS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "80px",
    viewBox: "0 0 52 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "meals-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "meals-S",
    fill: "#2800A0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.041585,0 C51.041585,0 34.374945,4.2916598 34.374945,47.91659 L42.708265,49.99992 L42.708265,79.16654 L51.041585,79.16654 L51.041585,0 Z M17.708305,39.58327 L17.708305,79.16654 L9.374985,79.16654 L9.374985,39.58327 L6.666656,39.58327 C3.124995,39.58327 0.2291663,36.8332744 0.01249998,33.33328 L0,33.33328 L0,4.16666 L6.24999,4.16666 L6.24999,22.91663 L10.41665,22.91663 L10.41665,4.16666 L16.66664,4.16666 L16.66664,22.91663 L20.8333,22.91663 L20.8333,4.16666 L27.08329,4.16666 L27.08329,33.33328 L27.07079,33.33328 C26.8541237,36.8332744 23.958295,39.58327 20.416634,39.58327 L17.708305,39.58327 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealsS);
export default __webpack_public_path__ + "static/media/meals-S.b2a3b0b24e74c4bfea79074562955c06.svg";
export { ForwardRef as ReactComponent };